import { render, staticRenderFns } from "./account_page.vue?vue&type=template&id=1f490288&scoped=true"
import script from "./account_page.vue?vue&type=script&lang=js"
export * from "./account_page.vue?vue&type=script&lang=js"
import style0 from "./account_page.vue?vue&type=style&index=0&id=1f490288&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f490288",
  null
  
)

export default component.exports